"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _methods = require("@/components/Store/SalesKPIRecord/methods");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var curDateTree = (0, _methods.getCurDateTree)(); // 获取当前时间相关 月份、季度、年份
var _default2 = exports.default = {
  props: {
    rsmList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    comment: {
      type: Function,
      default: function _default() {}
    },
    detail: {
      type: Function,
      default: function _default() {}
    },
    assignTasks: {
      type: Function,
      default: function _default() {}
    },
    exportReport: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    var weekSelectOptions = [{
      code: "0",
      name: "上周"
    }, {
      code: "1",
      name: "本周"
    }, {
      code: "2",
      name: "下周"
    }];
    return {
      weekSelectOptions: weekSelectOptions,
      searchValue: {
        type: "4",
        value: "1",
        rsmList: []
      },
      listLoading: false,
      currPage: 1,
      limit: 10,
      total: 0,
      list: [],
      sourceApi: null,
      defaultSort: {
        prop: "",
        order: ""
      }
    };
  },
  computed: {
    isMonthly: function isMonthly() {
      return this.searchValue.type == 1;
    },
    isQuarterly: function isQuarterly() {
      return this.searchValue.type == 2;
    },
    isYearly: function isYearly() {
      return this.searchValue.type == 3;
    },
    isWeekly: function isWeekly() {
      return this.searchValue.type == 4;
    },
    // 当前用户角色
    userRole: function userRole() {
      return this.$store.getters.roles[0];
    }
  },
  watch: {
    "searchValue.value": {
      handler: function handler(newVal, oldVal) {
        this.searchData();
      }
    },
    "searchValue.rsmList": {
      handler: function handler(newVal, oldVal) {
        this.searchData();
      }
    }
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;
      if (this.sourceApi) {
        this.sourceApi.cancel("cancel");
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: {
          type: this.searchValue.type,
          value: this.searchValue.value,
          rsmList: this.searchValue.rsmList,
          orderByField: this.defaultSort.prop,
          ascOrDesc: this.defaultSort.order === "ascending" ? "asc" : "desc"
        }
      };
      this.listLoading = true;
      this.$api.performanceReport.getVisitPlanList(param, this.sourceApi.token).then(function (res) {
        _this.listLoading = false;
        _this.list = res.data.items;
        _this.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this.listLoading = false;
      });
    },
    searchData: function searchData(param) {
      if (param) {
        this.searchValue = param.searchValue;
        this.defaultSort = param.defaultSort;
        this.currPage = param.currPage;
        this.limit = param.limit;
      } else {
        this.currPage = 1;
      }
      this.fetchData();
    },
    sortTable: function sortTable(_ref) {
      var column = _ref.column,
        prop = _ref.prop,
        order = _ref.order;
      if (!order) {
        this.defaultSort = {
          prop: "",
          order: ""
        };
        this.searchData();
        return;
      }
      this.defaultSort = {
        prop: prop,
        order: order
      };
      this.searchData();
    },
    exportHandler: function exportHandler() {
      var param = {
        type: this.searchValue.type,
        value: this.searchValue.value,
        rsmList: this.searchValue.rsmList,
        orderByField: this.defaultSort.prop,
        ascOrDesc: this.defaultSort.order === "ascending" ? "asc" : "desc"
      };
      this.exportReport(param);
    }
  }
};